import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'design-system-web';
import { TranslationKeys } from 'localization';

const TRANSLATION_KEYS: Record<
  'save' | 'cancel' | 'discardChanges' | 'keepEditing',
  TranslationKeys
> = Object.freeze({
  save:
    'web.admin.serviceRequest.settings.coverageHours.create.save',
  cancel:
    'web.admin.serviceRequest.settings.coverageHours.create.cancel',
  discardChanges:
    'web.admin.serviceRequest.settings.coverageHours.create.discardChanges',
  keepEditing:
    'web.admin.serviceRequest.settings.coverageHours.create.keepEditing',
});

type CoverageHoursPanelFooterProps = {
  isConfirmingClose: boolean;
  onDiscardChanges: () => void;
  onKeepEditing: () => void;
  onCancel: () => void;
};

export function CoverageHoursPanelFooter({
  isConfirmingClose,
  onDiscardChanges,
  onKeepEditing,
  onCancel,
}: CoverageHoursPanelFooterProps) {
  const { t } = useTranslation();

  if (isConfirmingClose) {
    return (
      <>
        <Button
          variant="secondary"
          size="large"
          testId="coverage-hours-discard-changes"
          onClick={onDiscardChanges}
        >
          {t(TRANSLATION_KEYS.discardChanges)}
        </Button>
        <Button
          variant="primary"
          size="large"
          testId="coverage-hours-keep-editing"
          onClick={onKeepEditing}
        >
          {t(TRANSLATION_KEYS.keepEditing)}
        </Button>
      </>
    );
  }

  return (
    <>
      <Button variant="primary" size="large" disabled>
        {t(TRANSLATION_KEYS.save)}
      </Button>
      <Button
        variant="secondary"
        size="large"
        testId="coverage-hours-cancel"
        onClick={onCancel}
      >
        {t(TRANSLATION_KEYS.cancel)}
      </Button>
    </>
  );
}
